import { useCallback, useEffect, useState } from 'react';
import { Button, Dropdown, Popover, Stack, Whisper } from 'rsuite';
import { t } from 'i18next';
import ArrowDownIcon from '@rsuite/icons/ArrowDown';
import '../styles/SupportDropdown.scss';

interface IProps {
  account: Record<string, any>;
  commonData?: Record<string, any>;
}

export const SupportDropdown = ({ account, commonData }: IProps) => {
  const [menus, setMenus] = useState<any[]>([]);

  useEffect(() => {
    if (commonData && account) {
      const menus = getPortalShowItems(commonData, account);
      setMenus(menus);
    }
  }, [commonData, account]);

  const h_key = {
    source_app: '',
    user_id: account?.user_id > 0 ? account?.user_id : 0,
    account_id: account?.account_id,
    user_fullaccess: account?.all_assets_access,
    partner_id: ''
  };

  const renderSupport = useCallback(
    ({ onClose, left, top, className }: any, ref: any) => {
      return (
        <Popover ref={ref} className={className} style={{ left, top }} full>
          <Dropdown.Menu>
            {menus?.length ? (
              <div className="menus-container">
                {menus.map((menu: Record<string, any>, menu_index: number) => (
                  <div key={menu.item_id + '_' + menu_index}>
                    <div
                      className="group-name"
                      style={{
                        borderBottom: '1px solid',
                        textTransform: 'uppercase',
                        fontSize: '10px',
                        paddingBottom: '6px',
                        fontWeight: 700
                      }}
                    >
                      {menu.display_name}
                    </div>
                    <div className="group-item">
                      {menu.items &&
                        menu.items.map(
                          (item: Record<string, any>, item_index: number) => (
                            <div
                              className="items-container"
                              key={item.app_id + '_' + item_index}
                            >
                              <form
                                method="post"
                                action={item.url}
                                style={{
                                  cursor:
                                    item.visibility === 'ShowDisabled'
                                      ? 'not-allowed'
                                      : ''
                                }}
                              >
                                <input
                                  type="hidden"
                                  name="h_key"
                                  value={JSON.stringify(h_key)}
                                />
                                <Button
                                  type="submit"
                                  name="submit_param"
                                  value="submit_value"
                                  style={{
                                    padding: '6px 0',
                                    width: '100%',
                                    justifyContent: 'left',
                                    background: 'transparent'
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: '12px'
                                    }}
                                  >
                                    {item.display_name}
                                  </span>
                                </Button>
                              </form>
                            </div>
                          )
                        )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="no-data"
                style={{
                  minHeight: '100px',
                  minWidth: '200px',
                  display: 'grid',
                  placeItems: 'center'
                }}
              >
                No Support Data
              </div>
            )}
          </Dropdown.Menu>
        </Popover>
      );
    },
    [menus]
  );

  return (
    <>
      <Whisper
        placement="bottomStart"
        trigger="click"
        speaker={renderSupport}
        controlId={`control-id-support`}
      >
        <Button appearance="link">
          <Stack alignItems="center" spacing={6}>
            <i
              className="icon-fortinetone-customerSupportIcon"
              style={{ fontSize: '1.2rem' }}
            />
            <span color="inherit">{t('common.header.support')}</span>
          </Stack>
          <ArrowDownIcon />
        </Button>
      </Whisper>
    </>
  );
};

const getPortalShowItems = (
  commonData: Record<string, any>,
  account: Record<string, any>
) => {
  if (commonData?.support_menu_items) {
    if (account?.support_menu) {
      let supportCombinedItems = commonData?.support_menu_items.map(
        (item: Record<string, any>) => {
          let target = account?.support_menu.find(
            (ele: Record<string, any>) => ele.item_id === item.item_id
          );
          return {
            ...item,
            ...target
          };
        }
      );
      let userVisibaleItems = supportCombinedItems.filter(
        (item: Record<string, any>) => {
          return account?.support_menu.some(
            (ele: Record<string, any>) =>
              ele.item_id === item.item_id && ele.visibility !== 'Hide'
          );
        }
      );
      const result = [...commonData?.support_menu_headers]
        .sort(
          (a: Record<string, any>, b: Record<string, any>) =>
            Number(a.order) - Number(b.order)
        )
        .map((item: Record<string, any>) => ({
          ...item,
          items: userVisibaleItems
            .filter(
              (subitem: Record<string, any>) =>
                subitem.section_header === item.display_name
            )
            .sort(
              (a: Record<string, any>, b: Record<string, any>) =>
                Number(a.order) - Number(b.order)
            )
        }));
      return result;
    }
  }
  return commonData?.support_menu_headers;
};
